import api from './api';

export default async function getServiceJson(url, json) {

  return api
    .get(url, 
    {
      headers: { 'Content-Type': 'application/json', },
      params: json
    })
    .then(response => {
      return {type: 'success', data: response.data};
    })
    .catch(error => {
      return {type:'error', data: {code: error.response.data.code, detail: error.response.data.detail}}
    });
}
